import React from 'react';
import Toast, { ToastProps } from './Toast';

export interface ToastPortalProps {
  toasts: ToastProps[];
  onClose: (id: string) => void;
}

const ToastPortal: React.FC<ToastPortalProps> = ({ toasts, onClose }) => (
  <div className='toast-portal' aria-live='polite' aria-atomic='true'>
    {toasts.map((toast) => (
      <Toast key={toast.id} {...toast} onClose={onClose} />
    ))}
  </div>
);

export default ToastPortal;
